import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {RegisteredRuleSchemaComponent} from '@github-ui/repos-rules-types/rules-types'
import {FilePathList} from './FilePathList'

export function FilePathRestrictions({field, value, onValueChange, readOnly}: RegisteredRuleSchemaComponent) {
  const ignoredFilePathsEnabled = isFeatureEnabled('rule_ignored_file_paths')

  return (
    <FilePathList
      field={field}
      value={value}
      onValueChange={onValueChange}
      readOnly={readOnly}
      boxName="Restricted file paths"
      buttonName={ignoredFilePathsEnabled ? 'Add restricted path' : 'Add file path'}
      blankslate="No file paths"
    />
  )
}
